import { ToolBase, ToolPointer } from './tool';

/** Farbfüllwerkzeug (B): Klick auf Fläche färbt mit der aktuellen Farbe. */
export class PaintTool extends ToolBase {
  readonly id = 'paint';
  readonly label = 'Farbe';
  readonly shortcut = 'B';
  readonly cursor = 'crosshair';
  readonly hint = 'Fläche anklicken zum Färben · Farbe im Panel rechts wählen';

  enter(): void {}
  exit(): void {
    this.ctx.renderer.hoverFaceId = null;
    this.ctx.requestUpdate();
  }

  pointerMove(e: ToolPointer): void {
    const faceId = this.ctx.renderer.pickFace(e.ndcX, e.ndcY, this.ctx.camera.camera);
    this.ctx.renderer.hoverFaceId = faceId;
    this.ctx.requestUpdate();
  }

  pointerDown(e: ToolPointer): void {
    if (e.button !== 0) return;
    const faceId = this.ctx.renderer.pickFace(e.ndcX, e.ndcY, this.ctx.camera.camera);
    if (faceId === null) return;
    const model = this.ctx.model;
    const face = model.faces.get(faceId);
    if (!face) return;
    // Geschlossene Gruppe → alle Flächen der Gruppe färben (wie SketchUp)
    const targets = model.isEditable(face) ? [faceId] : [...model.expandToGroups([], [faceId]).faces];
    if (targets.length === 0) return;
    this.ctx.beginEdit();
    for (const id of targets) {
      const f = model.faces.get(id);
      if (f) f.color = this.ctx.currentColor();
    }
    this.ctx.requestUpdate();
  }

  pointerUp(_e: ToolPointer): void {}
  cancel(): void {
    this.ctx.renderer.hoverFaceId = null;
    this.ctx.requestUpdate();
  }
}
